<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="8" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">就业方向</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">就业方向</div>
    </div>

    <div class="head01">
      <div>
        <Header :activeIndex="8" class="head02" v-if="!isMobile" />
      </div>
      <div class="head03">
        <div class="personal-info-page">
          <div v-for="(position, index) in dataTable" :key="position.name" class="job-item">
            <div class="info-row1">
              <label>就业方向{{ index + 1 }}：</label><span>{{ position.name }}</span>
              <label>匹配度：</label><span>{{ position.matchRate }}</span>
            </div>
            <div class="info-row">
              <label>工作内容：</label>
              <span>
                <li v-for="(item, index) in JSON.parse(position.jobResponsibilities)" :key="index">{{ item }}</li>
              </span>
            </div>
            <div class="info-row">
              <label>岗位要求：</label>
              <span>
                <li v-for="(item, index) in JSON.parse(position.positionRequirements)" :key="index">{{ item }}</li>
              </span>
            </div>
            <div class="info-row">
              <label>发展前景：</label>
              <span>
                {{ position.careerPath }}
              </span>
            </div>
            <div class="info-row2">
              <label>匹配分析：</label>
              <span>{{ generateTopMatchingSentence(position.matching) }}</span>
            </div>
          </div>
        </div>
        <div class="tupian">
          <img src="./img/wx.png" alt="微信二维码" style="width:50%;">
          <div>VIP就业咨询</div>
          <div>指导内容：</div>
          <div>1.个人综合素质分析</div>
          <div>2.就业方向深度指导</div>
          <div>3.综合素质提升与辅导</div>
          <div>4.就业岗位推荐</div>
          <div>电话：1391 0303 798</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "./Header.vue";
import Footer from './Footer.vue'
export default {
  name: 'recommend',
  components: { Header, Footer },
  data() {
    return {
      userId: sessionStorage.getItem("userId"),
      major: '',
      hollandResult: '',
      BASE_URL: 'https://zhiyedashi.com/job',
      BASE_URL1: 'https://zhiyedashi.com/info',
      BASE_URL2: "https://zhiyedashi.com/match",
      form: {
        applicants: [],
        jobs: [],
      },
      dataTable: [],
      isMobile: false,
      xueyexinxi: sessionStorage.getItem("xueyexinxi") === "true",
      zhiyeceshi: sessionStorage.getItem("zhiyeceshi") === "true",
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    let currentUserIdStr = String(this.userId);
    let storedData = localStorage.getItem(currentUserIdStr);
    if (!this.userId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    } else {
      if (storedData) {
        let parsedData = JSON.parse(storedData);
        // console.log(parsedData.userId, currentUserIdStr);
        if (parsedData.userId === currentUserIdStr) {
          this.dataTable = parsedData.dataTable;
        } else {
          // 判断学生信息和职业测试是否都有结果
          // 如果有
          console.log(this.zhiyeceshi, this.xueyexinxi, this.zhiyeceshi && this.xueyexinxi);
          if (this.zhiyeceshi && this.xueyexinxi) {
            this.selectResumes()
          } else {
            // 判断学生信息和职业测试哪个是false
            if (!this.xueyexinxi) {
              alert("请先填写学业信息")
              this.$router.push('/personalInf');
            } else {
              alert("请先填写测试问题")
              this.$router.push('/CareerQuiz');
            }
          }
        }
      } else {
        if (this.zhiyeceshi && this.xueyexinxi) {
          this.selectResumes()
        } else {
          // 判断学生信息和职业测试哪个是false
          if (!this.xueyexinxi) {
            alert("请先填写学业信息")
            this.$router.push('/personalInf');
          } else {
            alert("请先填写测试问题")
            this.$router.push('/CareerQuiz');
          }
        }
      }
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    generateTopMatchingSentence(matching) {
      // 创建一个数组存储匹配项
      const matchResults = [
        { label: '证书', value: matching.Certificate_matching_result },
        { label: '学历', value: matching.Education_matching_result },
        { label: '期望', value: matching.Expectation_matching_result },
        { label: '经验', value: matching.Experience_matching_result },
        { label: '兴趣', value: matching.Interest_matching_result },
        { label: '专业', value: matching.Major_matching_result },
        { label: '技能', value: matching.Skill_matching_result },
      ];

      // 过滤掉匹配度小于等于50%的项
      const filteredMatches = matchResults.filter(match => match.value > 50);

      // 按照匹配度值排序，并选择前四个
      const topMatches = filteredMatches.sort((a, b) => b.value - a.value).slice(0, 4);

      let sentence = "根据您的个人情况，我们发现您在以下几个方面的匹配度非常突出：";

      topMatches.forEach((match, index) => {
        sentence += `您的${match.label}匹配度为${match.value}%`;

        // 扩展每个匹配项的具体含义
        if (match.label === '证书') {
          sentence += "这意味着您具备了相关领域所需的专业认证，能够为您的工作提供专业支持，并证明您的行业知识在实践中的应用能力。";
        } else if (match.label === '学历') {
          sentence += "表明您具备了扎实的理论基础，能够在工作中深入分析和解决问题，支持您在复杂的工作环境中保持较高的工作效率。";
        } else if (match.label === '期望') {
          sentence += "这意味着您的职业目标和岗位要求高度契合，您对未来发展的规划使得您能够在工作中不断寻找新的机会，并推动自身成长。";
        } else if (match.label === '经验') {
          sentence += "这表示您已经积累了丰富的实践经验，能够迅速适应岗位的要求，处理复杂的工作任务，并能够为团队提供宝贵的实践支持。";
        } else if (match.label === '兴趣') {
          sentence += "这反映了您对工作内容的浓厚兴趣，您能够从内心投入到工作中，保持高度的工作热情，从而不断追求卓越。";
        } else if (match.label === '专业') {
          sentence += "证明您在该专业领域的知识深度，能够帮助您更好地解决工作中遇到的专业性难题，同时具备较强的行业敏感度。";
        } else if (match.label === '技能') {
          sentence += "这意味着您掌握了相关的关键技能，能够高效地执行工作任务，并在遇到挑战时灵活应对。";
        }

        // 根据位置判断是否加上逗号或结尾的句子
        if (index < topMatches.length - 1) {
          sentence += "";
        } else {
          sentence += "这使得您具备了出色的适应性和发展潜力，非常适合这个职位，能够为公司带来持续的价值和创新。";
        }
      });

      return sentence;
    },
    selectResumes() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL1}/admin/resumes/selectMajorH`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.major = data.data.major
          this.hollandResult = data.data.result
          this.pipei()
        })
        .catch(error => {
          console.error("查询失败2，原因是", error);
        });
    },
    pipei() {
      // 根据userId查询对应的专业  信息表，
      fetch(`${this.BASE_URL1}/admin/resumes/selectResumes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          const applicant = {
            applicant: data.data.userName,
            education: data.data.degree,
            major: data.data.major,
            certificates: JSON.parse(data.data.certificate),
            intern_experience: JSON.parse(data.data.internship),
            holland_result: this.hollandResult,
            expected_salary: "6000-8000",
          };

          // 直接 push 新对象到数组
          this.form.applicants.push(applicant);

          // 如果需要更新 form.applicants
          this.form.applicants = this.form.applicants;
          this.selectMajor();
        })
        .catch((error) => {
          console.error("用户信息查询失败，原因是", error);
        });
    },
    selectMajor() {
      fetch(`${this.BASE_URL}/admin/jobliebiao/selectByMajor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `major=${this.major}`,
      })
        .then((res) => res.json())
        .then((data) => {
          this.matchingResults = data.map((item) => item.jobId)

          const allJobs = data.map((item) => item.jobName)
          const allTopPostions = []
          let fetchPromises = [];

          for (let i = 0; i < allJobs.length; i += 25) {
            this.form.jobs = allJobs.slice(i, i + 25);

            let fetchPromise = fetch(`${this.BASE_URL}/admin/proxy`, {
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: `targetUrl=${this.BASE_URL2}&textent=${JSON.stringify(this.form)}`,
            })
              .then((res) => res.json())
              .then((data) => {
                const topThreePositions = data.results
                  .map((position) => ({
                    ...position,
                    matchRate: parseFloat(
                      position.Comprehensive_matching_score.split("/")[0]
                    ),
                    dimension_wise_matching: position.dimension_wise_matching
                  }))
                  .sort((a, b) => b.matchRate - a.matchRate) // 按 matchRate 降序排序
                  .reduce((uniquePositions, position) => {
                    // 检查当前 position.name 是否已经存在于 uniquePositions 中
                    if (!uniquePositions.some(p => p.name === position.job)) {
                      uniquePositions.push({
                        name: position.job,
                        matching: position.dimension_wise_matching,
                        matchRate: position.matchRate,
                      });
                    }
                    return uniquePositions;
                  }, []) // 使用 reduce 来去重并收集前 10 个不同的职位
                  .slice(0, 2);
                allTopPostions.push(...topThreePositions);
              })
              .catch((error) => {
                console.error("匹配职业失败，原因是", error);
              });

            // Push each fetch promise into the array
            fetchPromises.push(fetchPromise);
          }

          Promise.all(fetchPromises)
            .then(() => {
              const nameList = allTopPostions.map(item => `"${item.name}"`).join(",")
              fetch(`${this.BASE_URL}/admin/jobliebiao/selectFazhan`, {
                method: 'post',
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                body: `jobNames=${nameList}`
              })
                .then(res => res.json())
                .then(data => {
                  data.forEach(newItem => {
                    // 查找对应的原始result项
                    const matchIndex = allTopPostions.findIndex(item => item.name === newItem.jobName);

                    // 如果找到匹配的项，将其合并
                    if (matchIndex !== -1) {
                      allTopPostions[matchIndex] = {
                        ...allTopPostions[matchIndex],
                        ...newItem
                      };
                    } else {
                      // 如果没有找到对应的项，可以选择将其添加到result中
                      allTopPostions.push({
                        name: newItem.jobName,
                        matchRate: 0,
                        ...newItem
                      });
                    }
                  });
                  this.dataTable = allTopPostions.sort((a, b) => b.matchRate - a.matchRate);
                  let userIdStr = String(this.userId)
                  let savedata = {
                    userId: userIdStr,
                    dataTable: this.dataTable
                  }
                  // console.log(userIdStr, savedata);
                  localStorage.setItem(userIdStr, JSON.stringify(savedata))
                })
                .catch(error => {
                  console.error("查询发展路径报错，原因是", error);
                })
            })
            .catch((error) => {
              console.error("Error in fetching jobs:", error);
            });
        })
        .catch((error) => {
          console.error("用户信息查询失败，原因是", error);
        });
    }
  }
}
</script>
<style scoped>
.hengtiao1 {
  position: fixed;
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  z-index: 99;
}

.hengtiao {
  position: fixed;
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
  z-index: 99;
  margin-top: 8px;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  margin-bottom: 30px;
}

.head02 {
  position: fixed;
  margin-top: 58px;
}

.head03 {
  display: flex;
  margin-left: 310px;
}

.personal-info-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 60px;
  font-family: Arial, sans-serif;
  margin-top: 60px;
  /* height: 97vh; */
  border: 1px solid #ccc;
  border-radius: 20px;
  min-height: 75vh;
}

.info-row1 {
  display: flex;
  margin: 10px 0;
  font-weight: 700;
}

.info-row {
  display: flex;
  margin: 10px 0;
}

.info-row2 {
  display: flex;
  margin: 10px 0;
  margin-bottom: 50px;
}

label {
  width: 150px;
  font-weight: bold;
  color: #555;
  flex-shrink: 0;
  text-align: left;
}

span {
  flex: 1;
  color: #333;
  line-height: 25px;
  text-align: left;
}

.tupian {
  margin-top: 80px;
  line-height: 35px;
  margin-left: 1000px;
  font-weight: 700;
  font-size: 20px;
  position: fixed;
}

@media (max-width: 768px) {
  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
    position: static;
    margin-top: 0px;
  }

  .head01 {
    flex-direction: column;
    gap: 10px;
  }

  .head02 {
    margin-top: 41px;
  }

  .head03 {
    margin-left: 0px;
    justify-content: center;
    flex-direction: column;
    padding-top: 140px;
  }

  .personal-info-page {
    padding: 10px 20px;
    margin-top: 0px;
    min-height: auto;
    max-width: 100%;
  }

  .info-row1 {
    display: flex;
    flex-direction: column;
  }

  .info-row,
  .info-row2 {
    flex-direction: column;
    margin: 5px 0;
  }

  label {
    width: 100%;
    text-align: left;
  }

  span {
    width: 100%;
    text-align: left;
  }

  .tupian {
    margin-top: 40px;
    margin-left: 0;
    position: static;
    font-size: 16px;
    font-weight: 600;
  }

  .logo {
    width: 50px;
  }

  .pipeizhi {
    display: inline-block;
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recommend.vue